import { useEffect, useState } from 'react';
import { Card } from '@components/card/card';
import { CardBody } from 'react-bootstrap';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { Link, useParams , useSearchParams  } from 'react-router-dom';
import {
  getReturnsPurchaseOrderById,
  getReturnsPurchaseOrderByPurchasesOrderId,
  getDetailsById,
  cleanUpDetailsById
} from '@store/purchases/ReturnsPurchaseOrder/returnsPurchaseOrderSlice';
import NeatixModal from '@components/Modal/NeatixModal';
import AddReturn from './Add/AddReturn';
import Loading from '@components/Shared/Loader/Loading';
import UpdateReturn from './Update/UpdateReturn';
import PODetails from './PODetails/PODetails';

const PurchaseReturn = () => {
  const [show, setShow] = useState(false);
  const { Id } = useParams();
  const dispatch = useAppDispatch();

    const [searchParams] = useSearchParams();
  const type = (searchParams.get('type') || '').toLowerCase(); // ✅ query param



  const { DetailsById: data, loading2 , error2} = useAppSelector(s => s.ReturnsPurchaseOrder);

   useEffect(() => {
    if (!Id) return;
// debugger
    // ✅ اختر الـ thunk حسب type من الـ SearchParams
    if (type === 'add') {
      dispatch(getReturnsPurchaseOrderByPurchasesOrderId(Id));
    } else {
      dispatch(getDetailsById(Id));
    }

    return () => {
      dispatch(cleanUpDetailsById());
      // لو عندك cleanup ثاني خاص بالـ returns ضيفه هنا
    };
  }, [Id, type, dispatch]);


  // useEffect(() => {
  //   if (Id) {
  //     dispatch(getDetailsById(Id));
  //   }
  //   return () => {
  //     dispatch(cleanUpDetailsById());
  //   };
  // }, [Id]);

  
  //____________________________

  return (
    <div>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
              link: ':moduleHome'
            },
            {
              name: 'مردود مشتريات',
              link: '/PUR/PurchaseReturn'
            },
            {
              name: 'مردود جديد',
              link: null
            }
          ]}
          PageName={`مردود مشتريات `}
          subtitle={`أمر شـراء رقم ${data?.code ?? ''}`}
        />
      </div>

      <Card>
        <Loading loading={loading2} error={error2}>
          <CardBody className='pt-1'>
            <ul className='nav nav-tabs nav-tabs-v2 p-0'>
              <li className='nav-item me-3'>
                <Link to='#homev2' className='nav-link active' data-bs-toggle='tab'>
                  <i className='fas fa-file-alt me-2 text-theme fs-5'></i>
                  تفاصيل الأمر
                </Link>
              </li>

              <li className='nav-item me-3'>
                <Link to='#profilev2' className='nav-link' data-bs-toggle='tab'>
                  <i className='fas fa-undo me-2 text-theme fs-5'></i>
                  مردود جديد
                </Link>
              </li>
              <li className='nav-item me-3 dropdown'>
                <Link to='' className='nav-link dropdown-toggle' data-bs-toggle='dropdown'>
                  <i className='fas fa-history me-2 text-theme fs-5'></i>
                  المردودات السابقة
                </Link>

                <div className='dropdown-menu text-center'>
                  {data?.purTransactionsDtoList?.length > 0 ? (
                    data.purTransactionsDtoList?.map((m: any) => (
                      <Link to={`#${m.id}`} className='dropdown-item' data-bs-toggle='tab' key={m.id}>
                        <i className='fas fa-file-invoice me-2 text-theme'></i>
                        {m.code}
                      </Link>
                    ))
                  ) : (
                    <div className='dropdown-item text-warning'>
                      <i className='bi bi-exclamation-circle-fill me-2'></i>
                      لا توجد مردودات لأمر الشراء هذا
                    </div>
                  )}
                </div>
              </li>
            </ul>

            {/* تفاصيل الأمر  */}
            <div className='tab-content pt-3'>
              <div className='tab-pane fade show active' id='homev2'>
                <PODetails data={data} />
              </div>

              {/* مردود جديد */}
              <div className='tab-pane fade' id='profilev2'>
                {Object.keys(data ?? {})?.length > 0 && <AddReturn data={data} />}
              </div>

              {/* المردودات السابقة */}
              {data?.purTransactionsDtoList?.map((m: any) => {
                return (
                  <div className='tab-pane fade' id={m.id} key={m.id}>
                    {Object.keys(data ?? {})?.length > 0 && <UpdateReturn data={m} />}
                  </div>
                );
              })}
            </div>
          </CardBody>
        </Loading>
      </Card>

      <NeatixModal show={show} setShow={setShow} bodyClassName='p-0' size='xl' showHeader={false}>
        {Object.keys(data ?? {})?.length > 0 && <AddReturn data={data} />}
      </NeatixModal>
    </div>
  );
};

export default PurchaseReturn;
